import { make } from 'vuex-pathify';
import { state as configuration } from '@/store/configuration';

const getters = {
  ...make.getters(configuration),
};

export { getters };
